export const CANONICAL_ORIGIN = "https://skilmark.com";
